// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cms-page',
    // #endregion
    // #region Props
    props: {
        templateUrl: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        showCommandBar() {
            return this.$route.meta.showCommandBar ?? true;
        }
    },
    // #endregion
    // #region Constructor
    created() {
        this.loadData();
    },
    // #endregion
    // #region Core
    methods: {
        loadData() {
        },
        OnRefresh(event) {
            //Default
            event.preventDefault();
            //Notify
            this.$appHost.eventBus.emit('refresh');
        }
    },
    // #endregion
});
// #endregion
